"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimsForm = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var moment = require("moment");
var components_1 = require("@athena-portal/components");
var MotorClaim_1 = require("../../model/MotorClaim");
var services_1 = require("@falcon/services");
var RentersClaim_1 = require("../../model/RentersClaim");
var ClaimsForm = /** @class */ (function (_super) {
    __extends(ClaimsForm, _super);
    function ClaimsForm(props) {
        var _this = _super.call(this, props) || this;
        _this.state = _this.getEmptyState();
        _this.renderClaimTypeOptions = _this.renderClaimTypeOptions.bind(_this);
        _this.handleIncidentTypeChange = _this.handleIncidentTypeChange.bind(_this);
        _this.handleIncidentDateChange = _this.handleIncidentDateChange.bind(_this);
        _this.handleAnyClaimSpendChange = _this.handleAnyClaimSpendChange.bind(_this);
        _this.handleRefundAllowedChange = _this.handleRefundAllowedChange.bind(_this);
        _this.renderErrors = _this.renderErrors.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        return _this;
    }
    ClaimsForm.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (prevProps.selectedDriver !== this.props.selectedDriver) {
            this.setState(this.getEmptyState());
        }
    };
    ClaimsForm.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("form", { className: "row", onSubmit: this.handleSubmit, children: [this.state.errors.length > 0 && (0, jsx_runtime_1.jsx)("div", { className: "col-12 alert alert-danger", children: this.renderErrors() }), this.renderTypeQuestion(), (0, jsx_runtime_1.jsxs)("div", { className: "col-12 col-md-6 mt-4", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "incidentDateComponentDay", children: "Incident date" }), (0, jsx_runtime_1.jsxs)("div", { className: "display-flex", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("input", { id: "incidentDateComponentDay", className: "form-control", type: "number", name: "day", placeholder: "D", value: this.state.incidentDateComponents.day, onChange: this.handleIncidentDateChange }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("input", { id: "incidentDateComponentMonth", className: "form-control", type: "number", name: "month", placeholder: "M", value: this.state.incidentDateComponents.month, onChange: this.handleIncidentDateChange }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("input", { id: "incidentDateComponentYear", className: "form-control", type: "number", name: "year", placeholder: "YYYY", value: this.state.incidentDateComponents.year, onChange: this.handleIncidentDateChange }) })] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "col-12 mt-4", children: [(0, jsx_runtime_1.jsx)("label", { children: "Any claim spend?" }), (0, jsx_runtime_1.jsxs)("div", { className: "radio-group d-block", children: [(0, jsx_runtime_1.jsxs)("div", { className: "form-check form-check-inline", children: [(0, jsx_runtime_1.jsx)("input", { id: "anyClaimSpendYes", className: "form-check-input", type: "radio", name: "anyClaimSpend", value: "true", checked: this.state.claim.anyClaimSpend === true, onChange: this.handleAnyClaimSpendChange }), (0, jsx_runtime_1.jsx)("label", { className: "form-check-label", htmlFor: "anyClaimSpendYes", children: "Yes" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "form-check form-check-inline", children: [(0, jsx_runtime_1.jsx)("input", { id: "anyClaimSpendNo", className: "form-check-input", type: "radio", name: "anyClaimSpend", value: "false", checked: this.state.claim.anyClaimSpend === false, onChange: this.handleAnyClaimSpendChange }), (0, jsx_runtime_1.jsx)("label", { className: "form-check-label", htmlFor: "anyClaimSpendNo", children: "No" })] })] })] }), this.props.product === services_1.ProductsEnum.WOLF_MOTOR &&
                    (0, jsx_runtime_1.jsxs)("div", { className: "col-12 mt-4", children: [(0, jsx_runtime_1.jsx)("label", { children: "NCD Allowed?" }), (0, jsx_runtime_1.jsxs)("div", { className: "radio-group d-block", children: [(0, jsx_runtime_1.jsxs)("div", { className: "form-check form-check-inline", children: [(0, jsx_runtime_1.jsx)("input", { id: "refundAllowedYes", className: "form-check-input", type: "radio", name: "refundAllowed", value: "true", checked: this.state.claim.refundAllowed === true, onChange: this.handleRefundAllowedChange }), (0, jsx_runtime_1.jsx)("label", { className: "form-check-label", htmlFor: "refundAllowedYes", children: "Yes" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "form-check form-check-inline", children: [(0, jsx_runtime_1.jsx)("input", { id: "refundAllowedNo", className: "form-check-input", type: "radio", name: "refundAllowed", value: "false", checked: this.state.claim.refundAllowed === false, onChange: this.handleRefundAllowedChange }), (0, jsx_runtime_1.jsx)("label", { className: "form-check-label", htmlFor: "refundAllowedNo", children: "No" })] })] })] }), (0, jsx_runtime_1.jsx)("div", { className: "col-12 mt-2", children: (0, jsx_runtime_1.jsx)("button", { type: "submit", className: "btn btn-primary mr-0 float-right", children: this.props.submitText ? this.props.submitText : "Submit" }) })] }));
    };
    ClaimsForm.prototype.renderTypeQuestion = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "col-12 col-md-8", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "incidentType", children: "Type" }), (0, jsx_runtime_1.jsxs)("select", { id: "incidentType", className: "form-control", name: "claimTypeId", value: this.state.claim.claimTypeId, onChange: this.handleIncidentTypeChange, children: [(0, jsx_runtime_1.jsx)("option", { value: "", children: "Please choose..." }), this.props.product === services_1.ProductsEnum.MOTOR && this.renderClaimTypeOptions(), this.props.product === services_1.ProductsEnum.WOLF_MOTOR && this.renderClaimTypeOptions(), this.props.product === services_1.ProductsEnum.RENTERS && this.renderRentersClaimTypeOptions()] })] }));
    };
    ClaimsForm.prototype.renderClaimTypeOptions = function () {
        var claimTypes = new Array(MotorClaim_1.default.claimCount).fill(null).map(function (value, index) { return ({
            id: index + MotorClaim_1.default.claimTypeStartId,
            type: MotorClaim_1.default.getClaimType(index + MotorClaim_1.default.claimTypeStartId)
        }); });
        return claimTypes.map(function (claimType) { return ((0, jsx_runtime_1.jsx)("option", { value: claimType.id, children: claimType.type }, claimType.id)); });
    };
    ClaimsForm.prototype.renderRentersClaimTypeOptions = function () {
        var claimTypes = new Array(RentersClaim_1.default.claimCount).fill(null).map(function (value, index) { return ({
            id: index + RentersClaim_1.default.claimTypeStartId,
            type: RentersClaim_1.default.getClaimType(index + RentersClaim_1.default.claimTypeStartId)
        }); });
        return claimTypes.map(function (claimType) { return ((0, jsx_runtime_1.jsx)("option", { value: claimType.id, children: claimType.type }, claimType.id)); });
    };
    ClaimsForm.prototype.renderErrors = function () {
        var errorsToRender = this.state.errors.map(function (error, index) { return ((0, jsx_runtime_1.jsx)("li", { children: error }, index)); });
        return (0, jsx_runtime_1.jsx)("ul", { className: "mb-1", children: errorsToRender });
    };
    ClaimsForm.prototype.handleIncidentTypeChange = function (event) {
        event.persist();
        this.setState(function (state) {
            var _a;
            return ({
                claim: __assign(__assign({}, state.claim), (_a = {}, _a[event.target.name] = event.target.value, _a))
            });
        });
    };
    ClaimsForm.prototype.handleIncidentDateChange = function (event) {
        var _this = this;
        event.persist();
        this.setState(function (state) {
            var _a;
            return ({
                incidentDateComponents: __assign(__assign({}, state.incidentDateComponents), (_a = {}, _a[event.target.name] = event.target.value, _a))
            });
        }, function () {
            var incidentDateComponentsString = "";
            if (_this.state.incidentDateComponents.day && _this.state.incidentDateComponents.month &&
                _this.state.incidentDateComponents.year) {
                var incidentDateComponents = moment("".concat(_this.state.incidentDateComponents.year, "-").concat(_this.state.incidentDateComponents.month, "-").concat(_this.state.incidentDateComponents.day), "YYYY-M-D");
                if (incidentDateComponents.isValid()) {
                    incidentDateComponentsString = incidentDateComponents.format("YYYY-MM-DD");
                }
            }
            _this.setState(function (state) { return ({
                claim: __assign(__assign({}, state.claim), { incidentDate: incidentDateComponentsString })
            }); });
        });
    };
    ClaimsForm.prototype.handleAnyClaimSpendChange = function (event) {
        event.persist();
        this.setState(function (state) { return ({
            claim: __assign(__assign({}, state.claim), { anyClaimSpend: event.target.value === "true" })
        }); });
    };
    ClaimsForm.prototype.handleRefundAllowedChange = function (event) {
        event.persist();
        this.setState(function (state) { return ({
            claim: __assign(__assign({}, state.claim), { refundAllowed: event.target.value === "true" })
        }); });
    };
    ClaimsForm.prototype.validate = function () {
        var errors = [];
        var _a = this.state, claim = _a.claim, incidentDateComponents = _a.incidentDateComponents;
        if (!claim.claimTypeId) {
            errors.push("'Type' is a mandatory field");
        }
        if (!incidentDateComponents.day || !incidentDateComponents.month ||
            !incidentDateComponents.year || !claim.incidentDate) {
            errors.push("'Incident date' is a mandatory field");
        }
        else if (!moment(claim.incidentDate).isValid()) {
            errors.push("'Incident date' is not a valid date");
        }
        if (claim.anyClaimSpend !== true && claim.anyClaimSpend !== false) {
            errors.push("'Any claim spend?' is a mandatory field");
        }
        if (this.props.product === services_1.ProductsEnum.WOLF_MOTOR && claim.refundAllowed !== true && claim.refundAllowed !== false) {
            errors.push("'NCD Allowed?' is a mandatory field");
        }
        this.setState({
            errors: errors
        });
        return errors.length === 0;
    };
    ClaimsForm.prototype.handleSubmit = function (event) {
        event.preventDefault();
        var valid = this.validate();
        if (valid) {
            var claim = this.state.claim;
            var productName = null;
            if (this.props.product === services_1.ProductsEnum.MOTOR) {
                productName = services_1.ProductsEnum.MOTOR;
            }
            else if (this.props.product === services_1.ProductsEnum.WOLF_MOTOR) {
                productName = services_1.ProductsEnum.WOLF_MOTOR;
            }
            else if (this.props.product === services_1.ProductsEnum.RENTERS) {
                productName = services_1.ProductsEnum.RENTERS;
            }
            this.props.onSubmit({
                claimTypeId: claim.claimTypeId,
                incidentDate: claim.incidentDate,
                anyClaimSpend: claim.anyClaimSpend,
                personIds: claim.personIds,
                refundAllowed: claim.refundAllowed,
                product: productName
            });
            this.setState({
                claim: {
                    claimTypeId: "",
                    incidentDate: "",
                    anyClaimSpend: undefined,
                    personIds: claim.personIds,
                    refundAllowed: undefined,
                    product: undefined
                },
                incidentDateComponents: {
                    day: "",
                    month: "",
                    year: ""
                }
            });
        }
    };
    ClaimsForm.prototype.getEmptyState = function () {
        return {
            claim: {
                claimTypeId: "",
                incidentDate: "",
                anyClaimSpend: undefined,
                personIds: this.props.selectedDriver.driverIds,
                refundAllowed: undefined,
                product: undefined
            },
            incidentDateComponents: {
                day: "",
                month: "",
                year: ""
            },
            errors: []
        };
    };
    ClaimsForm = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], ClaimsForm);
    return ClaimsForm;
}(React.Component));
exports.ClaimsForm = ClaimsForm;
//# sourceMappingURL=ClaimsForm.js.map